import * as React from 'react';

import { Typography } from '@mui/material';

import BaseDialog, { BaseDialogProps } from '../Base';
import { ListAccessRequestsContainer } from './components/ListAccessRequestsContainer';

export const ListAccessRequestsV2Dialog: React.FC<BaseDialogProps> = (props) => {
  return (
    <BaseDialog
      {...props}
      width='1220px'
      height='720px'
      titleComponent={
        <Typography sx={{ fontSize: '18px', fontWeight: 500, fontFamily: 'Poppins' }}>
          Access list
        </Typography>
      }
      padding='8px 12px'
    >
      <ListAccessRequestsContainer />
    </BaseDialog>
  );
};
